import { PropsWithChildren, forwardRef } from 'react';

import Styled from '@/components/atomic/molecules/navigation/top-nav-items/wrapper/styled';

const TopNavItemsWrapper = forwardRef<HTMLUListElement, PropsWithChildren<any>>(
	(props, ref) => (
		<Styled ref={ref} {...props}>
			{props.children}
		</Styled>
	),
);

export default TopNavItemsWrapper;
